import request from "@/request";
import Setting from "@/settings";

export function getTenants() {
  // todo:从租户中心获取租户信息 目前是从租户站点服务端获取的
  var tenantCenterBaseURL = Setting.tenantCenterBaseURL.endsWith("/")
    ? Setting.tenantCenterBaseURL
    : Setting.tenantCenterBaseURL + "/";
  let url = `${tenantCenterBaseURL}api/tenant/GetList`;
  let x = request.get(url);
  return x;
}

export function login(data) {
  return request({
    url: "api/v1/system/auth/login",
    method: "post",
    data
  });
}

export function getLoginInfo() {
  return request({
    url: "api/v1/system/auth/GetUserInfo",
    method: "get"
  });
}

export function getUserGroups() {
  return request({
    url: "api/v1/system/auth/GetUserGroups",
    method: "get"
  });
}


export function loginPass(data) {
  return request({
    url: "api/v1/system/auth/LoginPass",
    method: "post",
    data
  });
}

export function loginWX(data) {
  console.log('data', data)
  return request({
    url: "api/v1/system/auth/LoginWX",
    method: "post",
    data
  });
}

export function LogByIntranet(data) {
  return request({
    url: "api/v1/system/auth/LogByIntranet?key=" + data,
    method: "get"
  });
}

export function LoginPassByMail(data) {
  return request({
    url: "api/v1/system/auth/LoginPassByMail",
    method: "post",
    data
  });
}


// // 域名
// var baseURL = `${Setting.apiBaseURL}`;
// var str = baseURL.replace(/\$\{tenant\}/, Setting.tenantCode);

// /**
//  * 修改指定用户密码
//  * @param {Object} params 修改内容
//  */
//  export const loginWX = params => {
//   return request.post(str+'/api/v1/system/auth/LoginWX', params);
// };